<div class="main-modal-container">
  <div class="close-modal-container">
    <img
      (click)="closeModal()"
      src="/assets/icons/ close-modal-icon.png"
      alt=""
    />
  </div>
  <div class="modal-content">
    <!--
    **
    * Delete Modal
    -->
    <ng-container *ngIf="modalType == 'deleteCompany'">
      <div class="deleteCompany">
        <h1 class="label-title">This company will be deleted</h1>
        <div class="container">
          <img src="/assets/icons/client-icon.png" alt="" />
          <label for="">{{
            company.companyName ? company.companyName : ""
          }}</label>
        </div>
        <h3>
          The user will be notified via email and all of the <br />
          members data will be deleted after 30 days.
        </h3>
        <button
          (click)="deleteCompany()"
          class="modal-button"
          gbui-button
          type="submit"
          [busy]="deleteCompanyLoading$ | async"
        >
          Delete
        </button>
      </div>
    </ng-container>
    <!--
    **
    * Delete Success Modal
    -->
    <ng-container *ngIf="modalType == 'deleteCompanySuccess'">
      <div class="deleteCompanySuccess">
        <img
          class="modal-success-icon"
          src="/assets/icons/success-modal-icon.png"
          alt=""
        />
        <h1 class="label-title">Deleted Successfully</h1>

        <h3>Company has been deleted successfully.</h3>
        <button
          (click)="closeModal()"
          class="modal-button"
          gbui-button
          type="submit"
        >
          Go Back
        </button>
      </div>
    </ng-container>

    <!--
    **
    * Remove Member
    -->
    <ng-container *ngIf="modalType == 'removeMember'">
      <div class="deleteMember" [formGroup]="form">
        <h1 class="label-title">Remove User</h1>
        <div class="container">
          <img src="/assets/icons/client-icon.png" alt="" />
          <label for="">{{ member.firstName }}</label>
          <!-- <label for="">{{ member?.fistName ? member?.fistName : "" }}</label> -->
        </div>
        <!-- <h3>Let this user know is being deleted.</h3> -->
        <!-- <label class="input-text">Email Message</label> -->
        <button
          (click)="removeMember()"
          class="modal-button"
          gbui-button
          type="submit"
        >
          Delete
        </button>
      </div>
    </ng-container>

    <!--
    **
    * Renew Contract Modal
    -->
    <ng-container *ngIf="modalType == 'contactCompany'">
      <div class="deleteCompany">
        <h1 class="label-title">Contact Company</h1>
        <div class="container">
          <img src="/assets/icons/client-icon.png" alt="" />
          <label for="">{{
            company.companyName ? company.companyName : ""
          }}</label>
        </div>
        <h3>
          {{ company.companyName }} will be notified that
          <br />
          its subscription is no longer active.
        </h3>

        <button
          [busy]="contactCompanyLoading$ | async"
          (click)="contactCompany()"
          class="modal-button"
          gbui-button
          type="submit"
        >
          Contact Company
        </button>
      </div>
    </ng-container>
    <!--
    **
    * Delete Success Modal
    -->
    <ng-container *ngIf="modalType == 'emailSent'">
      <div class="contact-company-success">
        <img
          class="modal-success-icon"
          src="/assets/icons/success-modal-icon.png"
          alt=""
        />
        <h1 class="label-title">Email Successfully Sent</h1>

        <!-- <h3>Contract has been renewed successfully.</h3> -->
        <button
          (click)="closeModal()"
          class="modal-button"
          gbui-button
          type="submit"
        >
          Go Back
        </button>
      </div>
    </ng-container>
  </div>
</div>
